import { HeartRoundSolidIcon as HeartFilledIcon } from "@wags/ui/product-icons.tsx";

import { Button } from "@wags/ui/button.tsx";
import { Drawer, DrawerContent } from "@wags/ui/drawer.tsx";
import { useState } from "react";
import { currentLocationAuthRedirectUrl } from "./auth-redirect";
import { readCurrentHash, restoreAuthHash } from "./browser/auth-hash";
import { MobileAuthDrawerContent } from "./mobile-auth-drawer-content";

export function SignInPromptSheet({
    title,
    description,
    open,
    onOpenChange,
    onSignIn,
}: {
    title: string;
    description: string;
    open: boolean;
    onOpenChange: (open: boolean) => void;
    onSignIn: () => void;
}) {
    const [authStep, setAuthStep] = useState<{
        returnUrl: string;
        returnHash: string;
    } | null>(null);
    const [wasOpen, setWasOpen] = useState(open);
    if (open !== wasOpen) {
        setWasOpen(open);
        if (open) setAuthStep(null);
    }

    const handleOpenChange = (nextOpen: boolean) => {
        if (!nextOpen && authStep) restoreAuthHash(authStep.returnHash);
        onOpenChange(nextOpen);
    };

    return (
        <Drawer open={open} onOpenChange={handleOpenChange}>
            {authStep ? (
                <MobileAuthDrawerContent
                    options={{ fallbackRedirectUrl: authStep.returnUrl }}
                />
            ) : (
                <DrawerContent
                    title={title}
                    className="max-h-[calc(100dvh-0.75rem)] min-h-0 gap-0 overflow-clip border-t-0 bg-true-white p-0"
                >
                    {/* oxlint-disable-next-line jsx-a11y/no-static-element-interactions -- stops React portal event propagation to parent Link */}
                    {/* oxlint-disable-next-line jsx-a11y/click-events-have-key-events -- not interactive, just blocks propagation */}
                    <div
                        className="flex flex-col items-center px-card pt-2 pb-[calc(env(safe-area-inset-bottom)+2rem)]"
                        onClick={(event) => event.stopPropagation()}
                        onPointerUp={(event) => event.stopPropagation()}
                    >
                        <HeartFilledIcon className="mt-2 mb-4 size-10 text-irish-setter" />
                        <h3 className="text-center text-item-title text-doberman-black">
                            {title}
                        </h3>
                        <p className="mt-2 max-w-[280px] text-pretty text-center text-body text-doberman-black/70">
                            {description}
                        </p>
                        <div className="mt-6 flex w-full flex-col gap-3">
                            <Button
                                className="h-12 w-full text-label text-doberman-black"
                                onClick={() => {
                                    onSignIn();
                                    setAuthStep({
                                        returnUrl:
                                            currentLocationAuthRedirectUrl(),
                                        returnHash: readCurrentHash(),
                                    });
                                }}
                            >
                                Sign in
                            </Button>
                            <button
                                type="button"
                                onClick={() => handleOpenChange(false)}
                                className="h-12 w-full text-body text-doberman-black/60 transition-colors hover:text-doberman-black"
                            >
                                Not now
                            </button>
                        </div>
                    </div>
                </DrawerContent>
            )}
        </Drawer>
    );
}
